const Tos = () => {
    return (
        <div className="Tos">
            <div className="TosInterface">
                <div className="TosTitle">Terms of Service</div>
                <div className="TosText">
                    <p style={{ fontSize: "calc(0.8vh + 0.8vw)" }}><b>Disclaimer</b></p>
                    This React App is developed using <span style={{ color: "#f3d736"}}><b>JavaScript</b></span> programming language and <span style={{ color: "#5ed3f3" }}><b>React</b></span> library and is completely state-handled.
                    It is backed by <span style={{ color: "#1f9265" }}><b>Django</b></span> web framework, which helps it deploy Service on simple editing of PDF files.
                    Our Service gives you a friendly and easy way to merge, split or compress PDF files.<br /><br />

                    <p style={{ fontSize: "calc(0.8vh + 0.8vw)" }}><b>Security and Privacy</b></p>
                    <u>We take security of your personal sensitive information very seriously</u>.
                    Our React App operates entirely within your browser and does not send any of your data to our server.
                    This is an additional level of security not found on mainstream PDF-editing platforms.
                    We utilize the latest web development technology available in the market to ensure that we cannot access your data in any way.<br /><br />

                    <p style={{ fontSize: "calc(0.8vh + 0.8vw)" }}><b>Donations</b></p>
                    We accept donations to support the enhancement of your experience and the development of our React App.
                    Donations are entirely optional and are not a requirement for use of our Service.
                    Before donating, please acknowledge and accept the fact that your donations are non-refundable.
                </div>
            </div>
        </div>
    )
};

export default Tos;
